/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const AppSpecificUninstallableReasonTypename = 'com.hubspot.marketplace.installs.models.compatibility.AppSpecificUninstallableReason';
export const getInstallCountRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCount',
  auth: 'external',
  fingerprint: '1GVyj-c0nbbLhlmz-StH-2abcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstallCountBatchRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCountBatch',
  auth: 'external',
  fingerprint: 'DNd7wgjU8CH7NryORdFGcmabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendInstallIntentRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'sendInstallIntent',
  auth: 'external',
  fingerprint: 'kRfYehF9JMeOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstallCompatibilityRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCompatibility',
  auth: 'external',
  fingerprint: '7_GA-wr3gJo0HRgH5-9WB2abcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};